// Shared type scale for the dashboard — every custom font-size in this folder
// should come from here, so bumping/rebalancing sizes stays a one-place edit
// instead of a hunt through scattered inline styles.
export const FONT = {
  micro: 11, // footer hints, "Expand" links, chart subtitles
  small: 12, // body copy, sub-captions, ranked-bar labels
  base: 13, // card header labels, panel row values
  title: 15, // chart/panel card titles
  stat: 32, // headline numbers (Statistic)
};
